import { render, staticRenderFns } from "./OrderkufanghuizongDetails.vue?vue&type=template&id=d4dee46a&scoped=true"
import script from "./OrderkufanghuizongDetails.vue?vue&type=script&lang=js"
export * from "./OrderkufanghuizongDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderkufanghuizongDetails.vue?vue&type=style&index=0&id=d4dee46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dee46a",
  null
  
)

export default component.exports